import { useContext, useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  createSearchParams,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { NavContext } from '../../../../../context/global_context'
import { notifyError } from '../../../../../utils/notifications'
import { getRequest } from '../../../../../services/base'
import DtcMappingItem from '../../DtcMappingItem'
import { Flex, Typography } from 'antd'

const DTCMappingSection = ({}) => {
  const intl = useIntl()
  let { vehicle } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const noExistingMappings =
    intl.formatMessage({ id: 'dtcs.connectorMapping.noExistingMappings' })

  const [value, dispatch] = useContext(NavContext)
  useEffect(() => {
    getDtcsDetails()
  }, [])

  const getDtcsDetails = async () => {
    let res = await getRequest(
      `/api/dtcs/mappings/?${createSearchParams({
        dtc_id: searchParams.getAll('dtc_id'),
      })}&vehicle=${vehicle}`
    )
    // base.js returns {status: false} rather than rejecting; without this the
    // `res?.data?.length > 0` test below silently renders an empty mapping.
    if (res?.status === false) {
      notifyError(dispatch, intl.formatMessage({ id: 'dtcs.mappings.loadError' }))
      return
    }
    if (res?.data?.length > 0) {
      let destination_only = false
      if (res?.data?.length > 0) {
        res?.data.forEach((dtcs_obj) => {
          if (dtcs_obj.destination_only) {
            destination_only = true
          }
        })
      }
      dispatch({
        type: 'header',
        data: {
          header: intl.formatMessage({ id: 'layout.adminTools' }),
          sub_header: `${intl.formatMessage({ id: 'layout.vehicleList' })} / ${vehicle} / DTCs / ${intl.formatMessage({ id: 'sidebar.taMappings' })} / ${intl.formatMessage({ id: 'dtcs.connectorMapping.dtcMappings' })}`,
          id: '',
          show_back_btn: true,
          dtc_details: res.data,
          vehicle: vehicle,
          back_btn_url: `/vehicles/${vehicle}/dtcs/listing`,
          destination_only: destination_only,
        },
      })
    }
  }

  return (
    <Flex className="col" gap={16}>
      <Typography.Title level={5} className="col-header">
        <Typography.Text className="title non-interactive">{intl.formatMessage({ id: 'dtcs.connectorMapping.dtcMappings' })}</Typography.Text>
      </Typography.Title>

      <Flex className="col-body">
        <Flex gap={16} className="scrollable">
          {value?.dtc_details?.length > 0 &&
            value?.dtc_details?.map((row, index) => {
              const length = value?.dtc_details.length
              const cssClass = (length > 1) ? (
                index === 0 ? 'first' : index === length-1 ? 'last' : ''
              ) : ('')
              return (
                <DtcMappingItem
                  key={`dtc_mapping_item-${index}-${row.id}`}
                  {...row}
                  destroyAllByDtcUrl={() => {}}
                  onDtcMappingChange={() => {
                    getDtcsDetails()
                  }}
                  wrapperClass={cssClass}
                />
              )
            })}
          {value?.dtc_details?.length === 0 && (
            <span className="no-data">{noExistingMappings}</span>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default DTCMappingSection
